module.exports = __webpack_public_path__ + "img/34.033d8a8b.jpg";